import React, {useEffect, useState} from 'react';
import Spinner from 'reactjs-simple-spinner';
import NoRolesSideBar from "../../common/NoRolesSideBar";
import NoRolesNavBar from "../../common/NoRolesNavBar";
import logo from "../../assets/images/logo.jpg";
import notfound from "../../assets/images/notfound.png"


const NoRolesHome = () => {

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setLoading(true);
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        setLoading(false);
    })

    return (
        <>
            {loading && (
                <div id="login-page">
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap mt-5">
                                <Spinner
                                    size="medium"
                                    message="Opening Dashboard..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {!loading && (
                <div>
                    <NoRolesSideBar/>

                    <div id="main-content" className="main-panel ps-container ps-theme-default">
                        <NoRolesNavBar/>
                        <div className="content">
                            <div className="container-fluid">
                                <ul className="breadcrumb">
                                    Welcome
                                </ul>
                                <hr/>
                                <div className="row">
                                    <div className="alert alert-info container text-center" role="alert">
                                        <strong className="font-weight-bold">Info!</strong> Your account doesn't have
                                        any roles therefore you can't perform any actions on the system.
                                        <br/>
                                        <br/>
                                        <span className="text-center">Please contact your system administrator.</span>
                                    </div>
                                    <div className="col-md-8 container">
                                        <center>
                                            <img src={notfound} width={1248} height={720} alt="Not Roles Found"/>
                                        </center>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            )}
        </>
    )
}

export default NoRolesHome;

